var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 67,
    viewBox: "0 0 90 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0654 1H10.9719L7.99076 46.7478L11.5889 52.5048L1 59.0842L4.0841 66.3833L15.4953 59.187L29.0654 55.0749L35.4392 48.701L40.271 50.3459L59.9065 48.3926L62.0654 46.8506L76.5607 46.2338L86.8411 43.8693L85.8131 40.5795L88.5888 37.0842L89 3.7758L76.6636 2.13094L45.9252 2.33655L42.3271 4.70104L40.0654 1Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCt);
export default __webpack_public_path__ + "static/media/CT.404c153930f3db3d1b2a1509209941f9.svg";
export { ForwardRef as ReactComponent };